import { Card, CardContent, CardHeader, CardTitle } from '@/common/ui/card'

interface SlideAnnouncementPreviewProps {
	content: string
}

export default function SlideAnnouncementPreview({
	content,
}: SlideAnnouncementPreviewProps) {
	return (
		<Card className="w-full">
			<CardHeader>
				<CardTitle className="text-lg">ตัวอย่างการแสดงผล</CardTitle>
			</CardHeader>
			<CardContent>
				<div className="relative overflow-hidden rounded-lg bg-gradient-to-r from-red-600 to-orange-500 shadow-lg">
					<div className="relative flex h-12 items-center">
						<div className="animate-marquee absolute whitespace-nowrap text-sm font-medium text-white">
							<span className="inline-block px-8">
								📢 {content || 'กรุณาใส่เนื้อหาประกาศ...'}
							</span>
						</div>
					</div>
					{/* Gradient fade edges */}
					<div className="pointer-events-none absolute left-0 top-0 h-full w-8 bg-gradient-to-r from-red-600 to-transparent"></div>
					<div className="pointer-events-none absolute right-0 top-0 h-full w-8 bg-gradient-to-l from-orange-500 to-transparent"></div>
				</div>
			</CardContent>
		</Card>
	)
}
